
import { ComponentType } from '@angular/cdk/overlay/index';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { Constants } from './constants';

export class Utilities {

  public static openSnackBar<T>(snackbar: MatSnackBar, component: ComponentType<T>, id: string, duration: number = 2500): MatSnackBarRef<T> {
    const snackBar = snackbar.openFromComponent<T>(component, {
      verticalPosition: 'bottom',
      data: id,
      horizontalPosition: 'right',
      panelClass: ['workplace-snackbar'],
      duration: duration
    });
    return snackBar;
  }

  public static getUrlWithoutQueryStrings(url): string {
    const parser = document.createElement('a');
    parser.href = url;
    const urlToReturn = `${parser.protocol}//${parser.hostname}/${parser.pathname}`;
    parser.remove();
    return urlToReturn;
  }

  public static getAuthorityUrlWithoutQueryStrings(url): string {
    const parser = document.createElement('a');
    parser.href = url;
    const urlToReturn = `${parser.protocol}//${parser.hostname}`;
    parser.remove();
    return urlToReturn;
  }

  public static isInIframe(window: Window) {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  public static getHostName(url): string {
    const parser = document.createElement('a');
    parser.href = url;
    const urlToReturn = `${parser.hostname}`;
    parser.remove();
    return urlToReturn;
  }

  public static getParamsFromUrl(url): Map<string, string> {
    const params = new Map<string, string>();
    const parser = document.createElement('a');
    parser.href = url;
    const query = parser.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=');
      params.set(pair[0], decodeURIComponent(pair[1]));
    }
    parser.remove();
    return params;
  }

  public static stringToEnum<T>(enumObj: T, str: keyof T): T[keyof T] {
    return enumObj[str];
  }

  public static formatAsGuid(value: string): string {
    return value.replace(/([0-z]{8})([0-z]{4})([0-z]{4})([0-z]{4})([0-z]{12})/, '$1-$2-$3-$4-$5');
  }

  // Generate v4 uuid (guid)
  public static uuidv4() {
    /* tslint:disable */
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
    /* tslint:enable */
  }

  public static getUsersLocale(defaultValue: string): string {
    if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
      return defaultValue;
    }
    const wn = window.navigator as any;
    let lang = wn.languages ? wn.languages[0] : defaultValue;
    lang = lang || wn.language || wn.browserLanguage || wn.userLanguage;
    return lang;
  }

   /**
 * detect IE
 * returns version of IE or -1, if browser is not Internet Explorer
 */
    public static detectIE(userAgent: string): number {

      const msie = userAgent.indexOf('MSIE ');
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(userAgent.substring(msie + 5, userAgent.indexOf('.', msie)), 10);
      }

      const trident = userAgent.indexOf('Trident/');
      if (trident > 0) {
        // IE 11 => return version number
        const rv = userAgent.indexOf('rv:');
        return parseInt(userAgent.substring(rv + 3, userAgent.indexOf('.', rv)), 10);
      }

      const edge = userAgent.indexOf('Edge/');
      if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(userAgent.substring(edge + 5, userAgent.indexOf('.', edge)), 10);
      }

      // other browser
      return -1;
    }

  // Detects if Safari is the browser https://stackoverflow.com/questions/7944460/detect-safari-browser/42189492
  public static isSafari(window: Window) {
    return window.navigator.vendor &&
      window.navigator.vendor.indexOf('Apple') > -1 &&
      window.navigator.userAgent &&
      window.navigator.userAgent.indexOf('CriOS') === -1 &&
      window.navigator.userAgent.indexOf('FxiOS') === -1;
  }

  /**
   * This can be used to detect if Workplace is browsed from within an Electron app such as MS Teams
   * @param window
   */
   public static isElectron(window: Window) {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return userAgent.indexOf(' electron/') > -1;
  }

  /**
   * This checks a magic querystring to block the main view from loading.
   * @param window
   */
   public static shouldLoadMain(window: Window) {
    const loadMain = (window.location.search.indexOf(Constants.SHOULD_NOT_LOAD_MAIN_KEY) === -1 && window.location.hash.indexOf(Constants.SHOULD_NOT_LOAD_MAIN_KEY) === -1);
    return loadMain;
  }


  public static getRootSiteUrl(input) {
    if (input) {
      input = input.replace(/(www\.)/i, '');
      if (!input.replace(/(www\.)/i, '')) {
        input = 'https://' + input;
      }

      const reg = /:\/\/(.[^/]+)/;
      return 'https://' + input.match(reg)[1];
    }
    return '';
  }

  public static getGroupSiteUrl(rootUrl, webId) {
    return rootUrl + '/_layouts/groupstatus.aspx?id=' + webId + '&target=' + Constants.COLLAB_UNIFIED_GROUPS_LINK_TARGET;
  }

  public static generateInitials(title: string): string {
    if (title) {
      const upperCaseLetters = title.replace(/[^A-Z]/g, '');
      if (upperCaseLetters.length >= 2) {
        return upperCaseLetters.substr(0, 2);
      } else {
        return title.substr(0, 2);
      }
    }
    return null;
  }

  /*
 * Matches the file type to a specfic icon.
 */
  public static getMSIcon(fileType: string): string {
    const type = fileType ? fileType.toLowerCase() : '';
    let iconClasses = 'ms-Icon ';

    switch (type) {
      case 'pdf':
        iconClasses += 'ms-Icon--PDF';
        break;
      case 'word':
        iconClasses += 'ms-Icon--WordLogo';
        break;
      case 'docx':
        iconClasses += 'ms-Icon--WordLogo';
        break;
      case 'excel':
        iconClasses += 'ms-Icon--ExcelLogo';
        break;
      case 'xlsx':
        iconClasses += 'ms-Icon--ExcelLogo';
        break;
      case 'powerpoint':
        iconClasses += 'ms-Icon--PowerPointLogo';
        break;
      case 'ppt':
        iconClasses += 'ms-Icon--PowerPointLogo';
        break;
      case 'onenote':
        iconClasses += 'ms-Icon--OneNoteLogo';
        break;
      case 'one':
        iconClasses += 'ms-Icon--OneNoteLogo';
        break;
      case 'visio':
        iconClasses += 'ms-Icon--VisioLogo';
        break;
      case 'vsdx':
        iconClasses += 'ms-Icon--VisioLogo';
        break;
      default:
        iconClasses += 'ms-Icon--TextDocument';
        break;
    }

    return iconClasses;
  }

  public static hexToRGBA(hex: string, alpha: string) {
    let r: number, g: number, b: number;
    if (hex.length === 4) {
      // short format: #f0f
      r = parseInt(hex.substr(1, 1) + hex.substr(1, 1), 16);
      g = parseInt(hex.substr(2, 1) + hex.substr(2, 1), 16);
      b = parseInt(hex.substr(3, 1) + hex.substr(3, 1), 16);
    } else {
      // full format: #ff00ff
      r = parseInt(hex.substr(1, 2), 16);
      g = parseInt(hex.substr(3, 2), 16);
      b = parseInt(hex.substr(5, 2), 16);
    }
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
  }
}
